export const FETCH_COOLDOWN_SUCCESS = "FETCH_COOLDOWN_SUCCESS";
export const FETCH_COOLDOWN_FAILURE = "FETCH_COOLDOWN_FAILURE";
export const FETCH_COOLDOWN_REQUEST = "FETCH_COOLDOWN_REQUEST";
